
import React from 'react';
import ScintillaOfArt from 'views/ScintillaOfArt'

const SecondarySchoolpage = () => {
  return <ScintillaOfArt/>;
};

export default SecondarySchoolpage;